<template>
    <div class="media-upload row">
        <div class="col-md-12">
            <component
                :is="uploadAdapter"
                :item-id="itemId"
                v-on:file-processed="$emit('file-processed', $event)"
                v-on:files-processed="onAllUploadsProcessed"
            />
        </div>
    </div>
</template>

<script>
import FilepondAdapter from '@/components/media/upload/adapters/Filepond';

export default {
    name: 'MediaUpload',
    components: {
        FilepondAdapter
    },
    props: {
        uploadAdapter: {
            type: String,
            default: 'FilepondAdapter'
        },
        itemId: {
            type: String, // for upload new version
        }
    },
    methods: {
        onAllUploadsProcessed() {
            this.$store.dispatch('hideMediaUploadModal');
        },
    }
}
</script>
